import { render, staticRenderFns } from "./DocumentHandover.vue?vue&type=template&id=16547238&scoped=true&"
import script from "./DocumentHandover.vue?vue&type=script&lang=js&"
export * from "./DocumentHandover.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_handover.scss?vue&type=style&index=0&id=16547238&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16547238",
  null
  
)

export default component.exports